<template>
  <div>
    <section class="technology-head">
      <div class="main-content">
        <h2>技术方案</h2>
        <p>为企业提供专业的一站式解决方案，让效率更高</p>
      </div>
    </section>
    <section class="coreTechnology">
      <div class="main-content">
        <div class="header">
          <span class="sudoku-technology sudoku-core"></span>
          <span>核心技术</span>
        </div>

        <div class="core_content" v-for="(core,idx) in coreTechnology" :key="idx"
             v-bind:style="{margin:idx==1||idx==4?'0 20px 30px 20px':'0 0 30px 0'}">
          <img v-lazy="core.cover" width="100%" height="160px"/>
          <p>{{core.title}}</p>
          <div>{{core.content}}</div>
        </div>
      </div>
    </section>
    <section class="deploymentPlan">
      <div class="main-content">
        <div class="header">
          <span class="sudoku-technology sudoku-deploy"></span>
          <span>部署方案</span>
        </div>
        <div class="content">
          <div class="plan" v-for="(dp, idx) in deploymentPlan" :key="idx">
            <span class="title">{{dp.title}}</span>
            <p>{{dp.content}}</p>
            <p class="application" v-if="dp.cases.length != 0">应用案例</p>

            <div class="correlation_div" style="display:inline-table"
                 v-for="(c, idx) in dp.cases" :key="idx"
                 v-bind:style="{marginRight:idx==dp.cases.length-1?'0':'30px'}">
              <router-link :to="{path: '/product#'+c.to}">
                <i class="sudoku-product-1" v-bind:class="c.logo"></i>
                <span>{{c.title}}</span>
              </router-link>
            </div>

          </div>
          <p class="note">*我们的产品支持多种部署方案，以上为举例，详情请仔细咨询工作人员。</p>
        </div>
      </div>
    </section>
    <section class="peopleService">
      <div class="main-content">
        <div class="header">
          <span class="sudoku-technology sudoku-personnel"></span>
          <span>人员与服务</span>
        </div>
        <div class="content wow fadeInUp">
          <div v-for="(ps, idx) in peopleService" :key="idx" style="width:370px;display:inline-table">
            <span class="psIcon sudoku-technology-1" v-bind:class="ps.style"></span>
            <div class="block" v-bind:style="{marginBottom:idx==peopleService.length-1?'-30px':'0'}">
              <span class="psTitle">{{ps.title}}</span>
              <p>{{ps.content}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

  import { WOW } from 'wowjs'

  import technology_1_1 from '../assets/img/technology_1_1.png'
  import technology_1_2 from '../assets/img/technology_1_2.png'
  import technology_1_3 from '../assets/img/technology_1_3.png'
  import technology_1_4 from '../assets/img/technology_1_4.png'
  import technology_1_5 from '../assets/img/technology_1_5.png'
  import technology_1_6 from '../assets/img/technology_1_6.png'
  export default {
    components: {},
    name: 'Technology',
    props: {},
    mounted() { new WOW({live: false}).init() },
    data(){
      return {
        coreTechnology: [{
          cover: technology_1_1,
          title: '语音识别技术（ASR）',
          content: '平安自主ASR引擎研发，平安自主研发、金融客服、电销、催收、风控场景及政务领域拥有成熟模型， 准确率高达85%以上。在智能交互、智能客服、语音机器人、文本机器人等有广泛应用。'
        }, {
          cover: technology_1_2,
          title: '自然语言处理技术（NLP）',
          content: '平安自有包含催收、电销教育、投诉、质检、报警等20多个语义模型，依托平安多场景多条线数十万语料训练支持， 金融场景模型准确率高达92%，质检风控全掌握。'
        }, {
          cover: technology_1_3,
          title: '情绪识别技术',
          content: '平安通过对语音中的韵律特征(语速、音量、音调等)、语音特征(振幅、共振幅频率、基音频率、持续时间等) 进行预处理特征提取和情感分类，并与文 本情绪识别相结合，实现实时情绪监控，投诉预警、舆情监控等'
        }, {
          cover: technology_1_4,
          title: '声纹识别技术',
          content: '是一种通过语音信号提取代表说话人身份的相关特征(如反映声门开合频率的基频 特征、反映口腔大小形状及声道长度的频谱特征等)，进而识别出说话人身份等方面的技术。目前平安拥有自研的声纹识别技术，支持十万级黑声纹库的1:n识别。'
        }, {
          cover: technology_1_5,
          title: '人脸识别技术',
          content: '平安人脸识别技术，在视频核身、 验证登录等领域有广泛应用，目前已覆盖平安产险、寿险信托、证券、普惠的8000+视频端坐席规模。'
        }, {
          cover: technology_1_6,
          title: '光学字符识别技术（OCR）',
          content: '平安自研智能OCR识别技术，其具备的自动感知被拍摄内容(如身份证、驾驶证行驶证、护照等)边沿、自动校正画面的歪斜、识别过程精准快速等技术特色，，打造了由基于视频的OCR+人脸认证的智能客服解决方案。'
        }],
        deploymentPlan: [{
          title: '私有云部署',
          content: '私有云部署 ，区别于本地化部署。本地部署是本地机房，实体服务和存储。而私有云，自有云平台，是虚拟服务虚拟存储设备。平安也支持私有云部署及本地部署服务。',
          cases: []
        }, {
          title: '公有云部署',
          content: '平安支持公有平安云的部署方式。所有的产品服务器、存储设备以及应用交互，都是在平安公有云服务器上部署，通过API或者专线的方式，跟客户本地或者其他云上的系统去做交互集成。',
          cases: [{
            logo: 'sudoku-A1',
            title: '一站式数字电话平台',
            to: 'A1'
          }, {
            logo: 'sudoku-C1',
            title: '智能知识平台',
            to: 'C1'
          }, {
            logo: 'sudoku-C5',
            title: '智能语音交互',
            to: 'C5'
          },{
              logo: 'sudoku-C2',
            title: '智能坐席助手',
            to: 'C2'
          }]
        }, {
          title: '混合云部署',
          content: '若客户涉及到后台的核心系统对接，或者敏感数据的调取服务，我们建议您采用混合云部署方案。会在客户本地有前置机的部署，前置机用来处理后台核心接口以及敏感信息脱敏。其他部分，存储、服务器、应用交互都是在公有平安云上。',
          cases: [{
            logo: 'sudoku-C1',
            title: '智能知识平台',
            to: 'C1'
          }, {
            logo: 'sudoku-C14',
            title: '电子签章平台',
            to: 'C14'
          }, {
            logo: 'sudoku-C7',
            title: '文本机器人',
            to: 'C7'
          }]
        }],
        peopleService: [{
          style: 'sudoku-dev',
          title: '敏捷开发',
          content: '高效作业、敏捷开发、全程服务'
        }, {
          style: 'sudoku-professional',
          title: '咨询专家',
          content: '业务规则梳理、流程调优、产品设计'
        }, {
          style: 'sudoku-share',
          title: '应用效果共享',
          content: '成熟且最新的规则引擎和AI模型应用成果共享'
        }]
      }
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/Technology.vue